<div class="header">
  <div class="action">
    <div class="close" (click)="close()">
      <mat-icon svgIcon="cross"></mat-icon>
    </div>
  </div>
</div>

<div class="modal-header">
  <h3 class="modal-title">{{ 'auth.code-email-help.title' | translate }}</h3>
</div>

<div class="modal-body">
  <p class="center">{{ 'auth.code-email-help.intro' | translate: { email: data.email } }}</p>

  <ol class="steps body-14">
    <li>{{ 'auth.code-email-help.steps.resend' | translate: { resend: ('auth.confirm-code.resend' | translate) } }}</li>
    <li>{{ 'auth.code-email-help.steps.refresh' | translate }}</li>
    <li>{{ 'auth.code-email-help.steps.folders.' + provider | translate }}</li>
    <li>
      {{ 'auth.code-email-help.steps.search' | translate }}
      <span class="search-query">
        <code>{{ searchQuery }}</code>
        <button class="button icon-only"
          type="button"
          [attr.aria-label]="'auth.code-email-help.copy' | translate"
          [cdkCopyToClipboard]="searchQuery"
          (cdkCopyToClipboardCopied)="onCopied()">
          <mat-icon svgIcon="copy"></mat-icon>
        </button>
        <!-- Only in the page while it shows, so a text selection does not pick it up. -->
        @if (copied) {
          <span class="copy-feedback body-12">
            {{ 'auth.code-email-help.copied' | translate }}
          </span>
        }
      </span>
    </li>
    <li>{{ 'auth.code-email-help.steps.address' | translate }}</li>
  </ol>

  <p class="contact body-14">
    {{ 'auth.code-email-help.steps.contact' | translate }}
    <a href="https://pet.calingo.ch/kontakt" target="_blank">{{ 'auth.contact-us' | translate }}</a>
  </p>
</div>

<div class="modal-footer">
  <button class="button primary" (click)="close()">
    {{ 'auth.code-email-help.close' | translate }}
  </button>
</div>
